import { ServiceResult } from '../models';
import {
  GetRecipeIngredientDiarysRequest,
  RecipeCustomerIngredientDiary,
  RecipeIngredientDiary,
  RevertRecipeCustomerIngredientDiaryActionRequest,
} from '../models/recipe-ingredient-diary.models';
import ApiService from './api-service';

class RecipeIngredientDiaryService extends ApiService {
  private static classInstance: RecipeIngredientDiaryService;

  private constructor() {
    super('RecipeIngredientDiary');
  }

  public static getInstance(): RecipeIngredientDiaryService {
    if (!this.classInstance) {
      this.classInstance = new RecipeIngredientDiaryService();
    }
    return this.classInstance;
  }

  public getRecipeIngredientDiary(recipeIngredientDiaryId: string): ServiceResult<RecipeIngredientDiary> {
    return this.get(`${this.persistUrl}/GetRecipeIngredientDiary?recipeIngredientDiaryId=${recipeIngredientDiaryId}`);
  }

  public getRecipeIngredientDiarys(request: GetRecipeIngredientDiarysRequest): ServiceResult<RecipeIngredientDiary[]> {
    return this.post(`${this.persistUrl}/GetRecipeIngredientDiarys`, request);
  }

  public getRecipeCustomerIngredientDiarys(
    customerId: string,
    startDate: Date | string,
    endDate: Date | string
  ): ServiceResult<RecipeCustomerIngredientDiary[]> {
    const start = typeof startDate === 'string' ? startDate : startDate.toISOString();
    const end = typeof endDate === 'string' ? endDate : endDate.toISOString();
    return this.get(
      `${this.persistUrl}/GetRecipeCustomerIngredientDiarys?customerId=${customerId}&startDate=${start}&endDate=${end}`
    );
  }

  public revertRecipeCustomerIngredientDiaryAction(
    request: RevertRecipeCustomerIngredientDiaryActionRequest
  ): ServiceResult<undefined> {
    return this.post(`${this.persistUrl}/RevertRecipeCustomerIngredientDiaryAction`, request);
  }
}

export default RecipeIngredientDiaryService;
